import styled from 'styled-components';
import Icon from '../../../Shared/Icons';

export const OutageBannerWrapper = styled.div`
  position: absolute;
  display: ${props => (props.isBannerDismissed ? 'none' : 'flex')};
  background-color: ${props => props.theme.carvana.yellow.warning};
  top: 0;
  padding-top: 20px;
  padding-bottom: 20px;
  z-index: 2;
  width: 100%;
  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    padding-top: 34px;
    padding-bottom: 32px;
  }
`;

export const OutageBannerTextWrapper = styled.div`
  font-family: ${props => props.theme.typography.fontFamily};
  font-style: normal;
  display: flex;
  flex-direction: column;
`;

export const OutageBannerHeader = styled.div`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 8px;
  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 3px;
  }
`;

export const OutageBannerDescription = styled.div`
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
`;

export const WarningWrapper = styled.div`
  padding-right: 17px;
  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    padding-right: 13px;
  }
`;

export const WarningTextWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  padding-left: 21px;
`;

export const CloseWrapper = styled.div`
  position: relative;
  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    margin-top: -8px;
  }
`;

export const CloseButton = styled.button`
  display: flex;
  justify-content: center;
  justify-self: end;
  margin-right: 24px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  width: 14px;
  height: 14px;
  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    width: 16px;
    height: 16px;
  }
`;

export const CloseIcon = styled(Icon)`
  fill: ${props => props.theme.carvana.blue.dark};;
  border: 2px solid;
`;

export const GrayedArea = styled.div`
  display: ${props => (props.isBannerDismissed ? 'none' : 'flex')};
  background-color: ${props => props.theme.carvana.blue.dark};
  position: fixed;
  min-height: 100vh;
  z-index: 1;
  opacity: 0.3;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
